import url from './apiUrl';
import handleResponse from "./handleResponse";

export default (token, payload) => {

    return fetch(`${url()}/posts/update`,{
            method: 'PUT',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": token
            },
            body: JSON.stringify(payload)
        })
        .then(res => handleResponse(res))
        .catch(err => console.log(err))
}